export default __webpack_public_path__ + "static/media/Cabeçalho_4_moblie.695254da.png";